/**
 * squash-indices.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";

/**
 * squashIndices is a pipe to remove empty indices from an iterable and return
 * an array with all elements autoindexed.
 */
@Pipe({name: "squashIndices", pure: false})
export class SquashIndicesPipe implements PipeTransform {
  /**
   * Loop through the provided array and push its values to a new array, in the
   * process reindexing them.
   * @param  {any[]} value
   * @return {any[]}
   */
  public transform (value : any[]) : any[] {
    if (!value)
    {
      console.log("Squashed falsy", value);
      return value;
    }
    if (!Array.isArray(value))
    {
      console.warn(value);
      throw new Error("SquashIndicesPipe only works on arrays!");
    }
    const result : any[] = [];
    value.forEach((v : any) => result.push(v));
    console.log("Squashed to ", result);
    return result;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/squash-indices.pipe.ts